import { defer } from "rxjs";
import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { switchMap } from "rxjs/operators";
import { SKIP_AUTH_HEADERS } from "./auth.context";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    // Requests that opted out are passed through untouched, without ever resolving the session.
    if (req.context.get(SKIP_AUTH_HEADERS)) {
        return next(req);
    }
    const authService = inject(AuthService);
    // Resolving the session is async, so defer keeps it cold: the lookup happens on subscribe
    // rather than when the interceptor is called. A failure to resolve it propagates to the caller.
    return defer(() => authService.addSingleSessionHeader(req.headers)).pipe(switchMap((headers) => next(req.clone({ headers }))));
};
